import { TeamMember, Location, PracticeArea, ContactInfo, Testimonial } from './types';
import andreiaImage from '../assets/ANDREIA-682x1024_ysj0bh.jpg';
import bashamImage from '../assets/Basham_kbmu9p.jpg';
import carolynaImage from '../assets/carolyna-681x1024_nyszdz.jpg';
import gabrielImage from '../assets/gabriel-681x1024_tqlart.jpg';
import teamPhotoImage from '../assets/IMG-20250918-WA0016-1024x681_rzlhdj.jpg';
import marianaImage from '../assets/IMG-20260127-WA0004_lar5s9.jpg';
import logoImage from '../assets/logo_mvf1jy.webp';
import manausImage from '../assets/manaus.webp';
import saoPauloImage from '../assets/sao-paulo_lzr1wd.png';
import sergioImage from '../assets/SERGIO-II_iuvh3a.jpg';
import thalissonImage from '../assets/thalisson-681x1024_kgg7yt.jpg';
import unida1Image from '../assets/unida1_r9fnxl.png';
import unida6Image from '../assets/unida6_cpilce.png';
import unida7Image from '../assets/unida7_gmgyhl.png';
import nataliaImage from '../assets/WhatsApp-Image-2026-01-23-at-17.13.52_wuhfqn.jpg';
import vitoriaImage from '../assets/vitoria.webp';
import natalImage from '../assets/natal.webp';
import joaoLucasImage from '../assets/joao-lucas-681x1024_yshaob.webp';
import emersonImage from '../assets/Emerson-_17.webp';
import rafaelaImage from '../assets/Rafaela-_35.webp';
import ricardoImage from '../assets/ricardo-681x1024_qljxv4.webp';
import thamyImage from '../assets/WhatsApp Image 2026-05-27 at 17.57.39.jpeg';
import yasminImage from '../assets/WhatsApp Image 2026-05-27 at 17.56.09.jpeg';

export const aboutText = `Desde 2011, a Mendes Assessoria Jurídica atua com um propósito claro: tornar o acesso à Justiça mais simples, acessível e real para quem realmente precisa.

Atendemos principalmente trabalhadores, aposentados, servidores públicos e consumidores que estão enfrentando problemas jurídicos — muitas vezes pela primeira vez — e precisam de orientação segura, direta e sem complicações.

A atuação profissional é pautada pelos princípios que regem a advocacia, com ênfase na transparência, na responsabilidade técnica e na adequada orientação dos clientes quanto às suas demandas.

Com estrutura voltada ao atendimento digital, o escritório presta serviços em todo o território nacional, promovendo maior acessibilidade e eficiência na comunicação com seus clientes.

A condução dos trabalhos está sob a responsabilidade do advogado Dr. Alvino Gabriel Novaes Mendes, que atua com dedicação à análise criteriosa de cada caso, buscando sempre a melhor solução jurídica dentro dos parâmetros legais aplicáveis.

O escritório preza pela construção de relações de confiança duradouras, baseadas na seriedade, no respeito e na efetiva entrega de valor jurídico aos seus clientes.`;

export const teamMembers: TeamMember[] = [
  {
    id: '1',
    name: 'Dr. Alvino Gabriel Novaes Mendes',
    role: 'Advogado e Fundador do Escritório Mendes Assessoria Jurídica',
    oab: 'OAB/PR 57.521 | OAB/SP 330.185 | OAB/SC 51.633 | OAB/RJ 248.783 | OAB/MG 231.150 | OAB/AL 22.695-A | OAB/AM A2366 | OAB/ES 44.006 | OAB/RN 23.598 | OAB/TO 14.402-A',
    image: gabrielImage,
    hierarchy: 1,
  },
  {
    id: '2',
    name: 'Thamy Marques Dada Mendes',
    role: 'Gestão Comercial e Atendimento Estratégico',
    image: thamyImage,
    hierarchy: 2,
  },
  {
    id: '3',
    name: 'Carolyna Ananias da Silva',
    role: 'Advogada',
    oab: 'OAB/PR 90.901',
    image: carolynaImage,
    hierarchy: 3,
  },
  {
    id: '4',
    name: 'Ricardo Brito Batista da Silva',
    role: 'Advogado',
    oab: 'OAB/PR 111.061 | OAB/SC 68.455 | OAB/MG 231.151',
    image: ricardoImage,
    hierarchy: 4,
  },
  {
    id: '5',
    name: 'Emerson Travagin',
    role: 'Advogado',
    oab: 'OAB/PR 115.338',
    image: emersonImage,
    hierarchy: 5,
  },
  {
    id: '6',
    name: 'Andréia Lopes Amaral Gislon',
    role: 'Advogada',
    oab: 'OAB/PR 124.373',
    image: andreiaImage,
    hierarchy: 6,
  },
  {
    id: '7',
    name: 'Thalisson Marcos Pereira Carvalho',
    role: 'Advogado',
    oab: 'OAB/PR 111.344 | OAB/SC 68.475 | OAB/MG 230.925',
    image: thalissonImage,
    hierarchy: 7,
  },
  {
    id: '8',
    name: 'João Lucas Checoni Rodrigues',
    role: 'Advogado',
    oab: 'OAB/PR 134.891',
    image: joaoLucasImage,
    hierarchy: 8,
  },
  {
    id: '9',
    name: 'Rafaela Gonçalves de Camargo',
    role: 'Advogada',
    oab: 'OAB/PR 119.156',
    image: rafaelaImage,
    hierarchy: 9,
  },
  {
    id: '10',
    name: 'Yasmin Yumi Menezes Fukushima',
    role: 'Advogada',
    oab: 'OAB/PR 134.909',
    image: yasminImage,
    hierarchy: 10,
  },
  {
    id: '11',
    name: 'Mariana Vitória Pardim Fernandes',
    role: 'Estagiária',
    image: marianaImage,
    hierarchy: 11,
  },
  {
    id: '12',
    name: 'Natalia Cordeiro',
    role: 'Assistente Jurídica',
    image: nataliaImage,
    hierarchy: 12,
  },
  {
    id: '13',
    name: 'Sérgio Crespi',
    role: 'Administrativo',
    image: sergioImage,
    hierarchy: 13,
  },
];

export const locations: Location[] = [
  {
    id: '1',
    address: 'Rua Manoel Ribas, 2280 - Centro',
    city: 'Paranavaí',
    state: 'PR',
    cep: 'CEP 87.704-000',
    phone: '(44) 3424-6448',
    image: unida1Image,
  },
  {
    id: '2',
    address: 'Atendimento digital e unidade de apoio',
    city: 'São Paulo',
    state: 'SP',
    cep: 'CEP 01.307-002',
    image: saoPauloImage,
  },
  {
    id: '3',
    address: 'Atendimento digital e unidade de apoio',
    city: 'Natal',
    state: 'RN',
    cep: '',
    image: natalImage,
  },
  {
    id: '5',
    address: 'Atendimento digital e unidade de apoio',
    city: 'Balneário Camboriú',
    state: 'SC',
    cep: 'CEP 88.337-000',
    image: unida6Image,
  },
  {
    id: '6',
    address: 'Rua Alameda Rolf Colin, 109, salas 06 e 07 - América',
    city: 'Joinville',
    state: 'SC',
    cep: 'CEP 89.204-070',
    image: unida7Image,
  },
  {
    id: '7',
    address: 'Atendimento digital e unidade de apoio',
    city: 'Manaus',
    state: 'AM',
    cep: '',
    image: manausImage,
  },
  {
    id: '8',
    address: 'Atendimento digital e unidade de apoio',
    city: 'Vitória',
    state: 'ES',
    cep: '',
    image: vitoriaImage,
  },
];

export const practiceAreas: PracticeArea[] = [
  {
    id: '1',
    title: 'Direito Previdenciário',
    intro: 'Contribuiu anos para a Previdência Social e agora enfrenta dificuldades para acessar o que é seu por direito? O INSS nega, corta ou calcula benefícios de forma incorreta com mais frequência do que se imagina. Nossa equipe atua para que você receba o benefício correto, no prazo adequado, com todo o suporte técnico necessário.',
    services: [
      'Aposentadoria por idade, por tempo de contribuição e aposentadoria especial',
      'Aposentadoria por invalidez e incapacidade permanente',
      'Auxílio por incapacidade temporária (antigo auxílio-doença)',
      'Auxílio-acidente',
      'Pensão por morte',
      'BPC/LOAS - Benefício de Prestação Continuada para idosos e pessoas com deficiência',
      'Revisão de benefícios negados ou cancelados administrativamente',
      'Aposentadoria PCD',
      'Planejamento previdenciário',
      'Recursos em processos administrativos no INSS',
    ],
    audience: 'Trabalhadores formais e informais, autônomos, rurais, domésticos, aposentados e pensionistas que tiveram benefícios negados, suspensos ou calculados abaixo do valor correto.',
  },
  {
    id: '2',
    title: 'Direito do Consumidor',
    intro: 'Empresas cobram o que não podem, inserem cláusulas abusivas em contratos e ignoram reclamações de consumidores contando com o desconhecimento de quem está do outro lado. O Código de Defesa do Consumidor existe para protegê-lo — e nosso escritório atua para fazer essa proteção valer na prática.',
    services: [
      'Cobranças indevidas e repetição do indébito',
      'Negativação indevida no SPC, Serasa, SCR e demais órgãos de proteção ao crédito',
      'Revisão de contratos com cláusulas abusivas',
      'Cancelamento de seguros e serviços não solicitados',
      'Problemas com planos de saúde — negativa de cobertura e reajustes abusivos',
      'Dano moral por falha na prestação de serviços',
      'Conflitos com operadoras de telefonia, energia elétrica e internet',
      'Vício e defeito em produtos e serviços',
      'Práticas comerciais abusivas',
    ],
    audience: 'Qualquer pessoa física que tenha sofrido abuso, cobrança indevida, negativação injusta ou falha grave na prestação de serviço por parte de empresa pública ou privada.',
  },
  {
    id: '3',
    title: 'Direito do Trabalho',
    intro: 'A relação de trabalho deveria ser justa para os dois lados — mas nem sempre é. Horas extras não pagas, demissão sem os devidos acertos, condições inadequadas de trabalho e vínculos empregatícios negados são situações que violam direitos garantidos por lei. Atuamos para que o trabalhador receba o que é seu, seja na fase administrativa ou judicial.',
    services: [
      'Rescisão indireta — demissão por justa causa do empregador',
      'Demissão sem justa causa — verificação e cobrança de verbas devidas',
      'Horas extras, adicionais noturnos, de insalubridade e de periculosidade',
      'FGTS não depositado ou saque indevido',
      'Férias, 13º salário e demais verbas rescisórias',
      'Reconhecimento de vínculo empregatício',
      'Acidente de trabalho e doença ocupacional',
      'Assédio moral e dano existencial',
      'Trabalho rural e doméstico',
    ],
    audience: 'Trabalhadores CLT, rurais, domésticos e autônomos que exercem atividade com características de vínculo empregatício — especialmente os que foram demitidos, tiveram direitos sonegados ou sofreram algum dano no ambiente de trabalho.',
  },
  {
    id: '4',
    title: 'Direito da Saúde',
    intro: 'Ter um plano de saúde ou ser atendido pelo SUS não garante automaticamente o acesso ao tratamento adequado. Negativas de cobertura, demora excessiva, descredenciamento de prestadores e reajustes abusivos são situações que colocam a saúde das pessoas em risco — e que podem ser contestadas juridicamente.',
    services: [
      'Negativa de cobertura por plano de saúde — internações, cirurgias, exames e medicamentos',
      'Reajuste abusivo de mensalidade de plano de saúde',
      'Cancelamento indevido de plano de saúde',
      'Fornecimento de medicamentos pelo Estado via ação judicial',
      'Acesso a tratamentos e procedimentos negados pelo SUS',
      'Responsabilidade civil médica e hospitalar por erro ou negligência',
      'Descredenciamento de médicos ou hospitais sem comunicação adequada',
    ],
    audience: 'Beneficiários de planos de saúde que tiveram cobertura negada, pacientes do SUS com tratamento negado ou atrasado, e pessoas que sofreram danos decorrentes de erro médico ou hospitalar.',
  },
  {
    id: '5',
    title: 'Direito de Família',
    intro: 'Questões familiares envolvem emoção, histórico e relações que vão muito além do processo jurídico. Nossa atuação nessa área é marcada pela escuta, pelo cuidado e pelo compromisso com soluções que preservem ao máximo o bem-estar de todos os envolvidos — especialmente das crianças.',
    services: [
      'Divórcio consensual e litigioso',
      'Guarda e regulamentação de visitas',
      'Pensão alimentícia — fixação, revisão e execução',
      'Investigação e reconhecimento de paternidade',
      'União estável — reconhecimento e dissolução',
      'Partilha de bens',
      'Curatela e tutela',
    ],
    audience: 'Pessoas em processo de separação, divórcio ou reorganização familiar; pais com questões de guarda, visita ou pensão alimentícia; familiares que necessitam de curatela ou tutela para um parente.',
  },
  {
    id: '6',
    title: 'Direito Bancário',
    intro: 'Bancos e financeiras aplicam juros abusivos, cobram tarifas não autorizadas, realizam descontos indevidos em benefícios e empurram empréstimos sem o consentimento claro do cliente. A legislação brasileira protege o consumidor financeiro — e nosso escritório atua para fazer essa proteção ser cumprida.',
    services: [
      'Revisão de contratos de empréstimo com juros abusivos',
      'Cancelamento e restituição de seguros contratados sem consentimento',
      'Descontos indevidos em benefícios do INSS (RMC e RCC) — empréstimo consignado não solicitado',
      'Superendividamento — renegociação e proteção judicial',
      'Portabilidade de crédito recusada indevidamente',
      'Cobrança de tarifas bancárias não autorizadas',
      'Fraudes e golpes com responsabilidade da instituição financeira',
      'Negativação indevida por dívida bancária contestada',
    ],
    audience: 'Aposentados, pensionistas e trabalhadores que tiveram descontos não autorizados em seus benefícios ou salários, consumidores com contratos bancários abusivos e pessoas em situação de superendividamento.',
  },
  {
    id: '7',
    title: 'Direito Civil',
    intro: 'O Direito Civil regula as relações entre pessoas — contratos, propriedades, responsabilidades e obrigações que surgem na vida cotidiana. Quando essas relações geram conflito, prejuízo ou descumprimento de acordos, o caminho jurídico existe para restabelecer o equilíbrio e reparar os danos causados.',
    services: [
      'Revisão e elaboração de contratos em geral',
      'Reparação de danos materiais e morais',
      'Conflitos entre vizinhos — uso de propriedade, limites e perturbações',
      'Responsabilidade civil por acidentes e negligências',
      'Cobranças de dívidas e inadimplemento contratual',
      'Servidão administrativa e indenização por restrição de propriedade',
      'Usucapião',
      'Inventário e partilha extrajudicial',
    ],
    audience: 'Pessoas físicas que sofreram prejuízo por descumprimento de contrato, acidentes, danos causados por terceiros, ou que precisam resolver questões relacionadas a bens, dívidas e propriedades.',
  },
];

export const testimonials: Testimonial[] = [
  {
    id: '1',
    area: 'Direito Previdenciário',
    quote: 'Tentei minha aposentadoria por invalidez duas vezes pelo INSS e as duas vezes foi negada. Fiquei mais de um ano sem saber o que fazer. Uma amiga me indicou o escritório e em poucos meses meu benefício foi aprovado. Fui atendida com muita atenção, me explicaram tudo sem complicar e nunca fiquei sem resposta quando precisei. Recomendo de olhos fechados.',
    author: 'Maria Aparecida S. — Aposentada, Paranavaí - PR',
  },
  {
    id: '2',
    area: 'Direito do Trabalho',
    quote: 'Trabalhei por oito anos na mesma empresa, fui mandado embora e não recebi nem metade do que era meu por direito. Não sabia nem por onde começar. O Dr. Alvino foi direto ao ponto, explicou o que eu tinha a receber e resolveu tudo. No final recebi muito mais do que esperava. Atendimento sério e de confiança.',
    author: 'Carlos Eduardo R. — Trabalhador CLT, Cuiabá - MT',
  },
  {
    id: '3',
    area: 'Direito Bancário',
    quote: 'Percebi que estavam descontando um seguro no meu benefício que eu nunca contratei. Já tinha tentado cancelar pelo banco e não conseguia. Entrei em contato com o escritório, me orientaram rapidinho e conseguiram cancelar o desconto e recuperar os valores que tinham sido cobrados indevidamente. Foi mais simples do que eu imaginava.',
    author: 'Joana T. — Aposentada, Itajaí - SC',
  },
  {
    id: '4',
    area: 'Direito do Consumidor',
    quote: 'Fui negativado por uma dívida que eu nem reconhecia. Estava impedido de financiar, abrir conta, fazer qualquer coisa. Entrei em contato com o escritório pelo WhatsApp mesmo, sem precisar ir pessoalmente, e resolveram minha situação. Nome limpo e ainda recebi indenização pelo dano moral. Não sabia que tinha esse direito.',
    author: 'Roberto M. — Autônomo, Loanda - PR',
  },
];

export const contactInfo: ContactInfo = {
  phone: '(44) 3424-6448',
  whatsapp: '(44) 9 9992-0228',
  instagram: 'mendesassessoriajuridica',
  email: 'alvinogabriel@mendesassessoriajuridica.com.br',
  address: 'Rua Manoel Ribas, 2280 - Centro',
  cityState: 'Paranavaí - PR',
  cep: 'CEP 87.704-000',
  link: 'https://api.whatsapp.com/send?phone=5544999920228&text=Ol%C3%A1%2C%20desejo%20falar%20com%20Mendes%20Assessoria%20Jur%C3%ADdica%21',
  mapEmbedUrl: 'https://www.google.com/maps?q=Rua%20Manoel%20Ribas%202280%20Centro%20Paranavai%20PR%2087704-000&output=embed',
};

export const teamPhoto = teamPhotoImage;
export const logoTransparent = logoImage;
export const heroBackground = bashamImage;
